import { apiClient } from '@/lib/api/api-client'

export interface BillingOperation {
  operationId: string
  kind: 'checkout' | 'billing'
  state: 'open' | 'processing' | 'needs_review' | 'awaiting_payment'
  canCancel: boolean
  url?: string
}

const base = (organizationId: string) =>
  `/subscriptions/organizations/${encodeURIComponent(organizationId)}`

export const billingOperationsApi = {
  cancelPayment: async (
    organizationId: string,
    operationId: string,
  ): Promise<{ state: 'confirmed' | 'canceled' }> =>
    (
      await apiClient<{ data: { state: 'confirmed' | 'canceled' } }>(
        `${base(organizationId)}/billing-operation/cancel-payment`,
        { method: 'POST', body: { operationId } },
      )
    ).data,
  status: async (organizationId: string): Promise<BillingOperation | null> =>
    (
      await apiClient<{ data: BillingOperation | null }>(
        `${base(organizationId)}/billing-operation`,
      )
    ).data,
  cancelCheckout: async (
    organizationId: string,
    operationId: string,
  ): Promise<void> => {
    await apiClient(`${base(organizationId)}/checkout/cancel`, {
      method: 'POST',
      body: { operationId },
    })
  },
}
